import { Tr, Td, Th } from '@patternfly/react-table'
import { useCallback } from 'react'
import * as React from 'react'

import { parseQuestionValue } from '@app/domain/form/form.helpers'
import type { Question } from '@app/domain/instrument/types'
import { InfoTooltip } from '@app/utils/info-tooltip-icon'

import { ResponseHistoryRowTooltipContent } from './response-history-row-tool-tip-content'

interface InstrumentListRowProps {
  question: Question
  responses: string[]
}

export const ResponseHistoryRow = ({
  question,
  responses,
}: InstrumentListRowProps) => {
  const renderResponse = useCallback(
    (questionValue: string) => {
      if (question.options?.length > 0) {
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: parseQuestionValue(question, questionValue),
            }}
          />
        )
      } else {
        return parseQuestionValue(question, questionValue)
      }
    },
    [question],
  )

  const createTooltip = () => {
    if (question.options) {
      return (
        <InfoTooltip
          content={
            <ResponseHistoryRowTooltipContent
              label={question.label}
              options={question.options}
              inputType={question.inputType}
            />
          }
        />
      )
    }
    return null
  }

  return (
    <Tr>
      <Th isStickyColumn modifier="wrap" width={10}>
        <span dangerouslySetInnerHTML={{ __html: question.label }} />
        {createTooltip()}
      </Th>
      {responses.map((response, idx) => (
        <Td width={10} modifier="wrap" key={idx}>
          {renderResponse(response)}
        </Td>
      ))}
    </Tr>
  )
}
